<div class="container">
    <ckeditor [editor]="Editor" (blur)="save($event)" [data]="item.description"></ckeditor>
</div>